import { gql } from '@apollo/client';

export const CREATE_PASSWORD_MUTATION = gql`
  mutation CreatePassword($email: String!) {
    createPassword(email: $email) {
      message
      type
    }
  }
`;